import React from 'react';
import PropTypes from 'prop-types';
import { getColor } from 'helpers/utils';
import ReactEChartsCore from 'echarts-for-react/lib/core';
import * as echarts from 'echarts/core';
import { BarChart } from 'echarts/charts';
import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent,
  ToolboxComponent
} from 'echarts/components';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
  TitleComponent,
  TooltipComponent,
  GridComponent,
  BarChart,
  CanvasRenderer,
  LegendComponent,
  ToolboxComponent
]);

const CashFlowChart = ({ xAxisData, cumulativeCashFlow, earnings }) => {
  const getOption = () => ({
    color: [getColor('info'), getColor('warning')],
    legend: {
      data: ['Cumulative Cash Flow', 'Earnings'],
      textStyle: {
        color: getColor('gray-700')
      },
      left: 0
    },
    toolbox: {
      feature: {
        magicType: {
          type: ['stack', 'tiled']
        }
      },
      iconStyle: {
        borderColor: getColor('gray-700'),
        borderWidth: 1
      }
    },
    tooltip: {
      trigger: 'item',
      padding: [7, 10],
      backgroundColor: getColor('gray-100'),
      borderColor: getColor('gray-300'),
      borderWidth: 1,
      transitionDuration: 0,
      axisPointer: {
        type: 'none'
      }
    },
    xAxis: {
      data: xAxisData,
      splitLine: { show: false },
      splitArea: { show: false },

      axisLabel: {
        color: getColor('gray-600')
      },

      axisLine: {
        lineStyle: {
          color: getColor('gray-400')
        }
      }
    },
    yAxis: {
      splitLine: {
        lineStyle: {
          color: getColor('gray-200')
        }
      },
      axisLabel: {
        color: getColor('gray-600')
      }
    },
    series: [
      {
        name: 'Cumulative Cash Flow',
        type: 'bar',
        stack: 'one',
        data: cumulativeCashFlow
      },
      {
        name: 'Earnings',
        type: 'bar',
        stack: 'one',
        data: earnings
      }
    ],
    grid: {
      top: '10%',
      bottom: 10,
      left: 5,
      right: 7,
      containLabel: true
    }
  });
  return (
    <ReactEChartsCore
      echarts={echarts}
      option={getOption()}
      // style={{ height: '21.88rem' }}
    />
  );
};

CashFlowChart.propTypes = {
  xAxisData: PropTypes.array.isRequired,
  cumulativeCashFlow: PropTypes.array.isRequired,
  earnings: PropTypes.array.isRequired
};

export default CashFlowChart;
